import React, { useEffect, useState } from "react";
import ResultEmotii from "../../images/img-result-emotii.png";
import ArrowPreviousDate from "../../images/arrow-prvs-date.svg";
import IconNote from "../../images/icn-note.svg";
import ArrowNextDate from "../../images/arrow-next-date.svg";
import IconEditNote from "../../images/icn-edit-note.svg";
import IconCheck from "../../images/icn-check.svg";
import IconNav from "../../images/icn-nav.svg";

import AccordianItem from "./AccordianItem";
import useFooter from "../../hooks/useFooter";
import BrandingFooter from "../Footer/BrandingFooter";
import classNames from "classnames";
import { formatDate } from "../../utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import { updateAssessment } from "../../store/slices/assessment";
import { setPopupComponent } from "../../store/slices/ui";

const colorClassArr = ["bg-green-1", "bg-green-2", "bg-blue-1", "bg-blue-2"];
const colorRGBAArr = [
  "rgba(22, 163, 74, 0.2)",
  "rgba(34, 197, 94, 0.2)",
  "rgba(37, 99, 235, 0.2)",
  "rgba(59, 130, 246, 0.2)",
];

function Result({ isVisible }) {
  const dispatch = useDispatch();
  const { results, data: assessment } = useSelector(
    (state) => state.assessment
  );

  const [activeItem, setActiveItem] = useState(null);
  const [activeResult, setActiveResult] = useState(0);
  const [editingNote, setEditingNote] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [noteValue, setNoteValue] = useState();
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useFooter(isVisible, <BrandingFooter />);

  const createFreeAccount = () => {
    sessionStorage.setItem("anonymous_user_assessment", results[0]["id"]);
    sessionStorage.setItem(
      "anonymous_user_details",
      JSON.stringify(assessment.patient)
    );
    loginWithRedirect();
  };

  const onEdit = async () => {
    const { data } = await dispatch(
      updateAssessment({
        authId: results[activeResult].authId,
        assessmentId: results[activeResult].assessmentId,
        note: noteValue,
      })
    );

    setEditingNote(false);
    return Promise.resolve(true);
  };

  const getDiffValue = (title, index) => {
    const currentAssessment =
      results[activeResult]?.assessmentData?.questions[index]?.value;
    const previousAssessment =
      results[activeResult - 1]?.assessmentData?.questions[index]?.value;

    if (index > results[activeResult]?.assessmentData?.questions?.length - 1) {
      return 0;
    }

    const multiplier = 100;
    const valueDifference = currentAssessment - previousAssessment || 0;
    const val = parseInt(multiplier * valueDifference);

    return isNaN(val) ? 0 : val;
  };

  useEffect(() => {
    if (!results.length || showComment) {
      return;
    }
    setActiveResult(results.length - 1);
  }, [results]);

  useEffect(() => {
    if (!results.length) {
      return;
    }
    setNoteValue(results[activeResult].note);
  }, [activeResult]);

  if (!results || !results[activeResult]) {
    return null;
  } else
    return (
      <div className="h-full bg-result-main">
        {" "}
        <div className="block-result-main">
          <div
            className={classNames("block_main_content", {
              "no-login-user": !isAuthenticated,
            })}
            id="close_note"
          >
            <div className="inner_result_header show-slide">
              <div className="result-header-bar">
                <a href="/" class="btn-create-free-account">
                  {isAuthenticated ? (
                    <span>Home</span>
                  ) : (
                    <>
                      Take <span>Emotii again!</span>
                    </>
                  )}
                </a>
                <div className="result-title">
                  <h1 className="">Your Results</h1>
                  <img src={ResultEmotii} alt="" className="-my-7" />
                  <a
                    href="#popup-about-result"
                    className="link-about-result"
                    onClick={() => dispatch(setPopupComponent("AboutResults"))}
                  >
                    About your results
                  </a>
                </div>

                <div
                  className={classNames("create-account-box", {
                    block: !isAuthenticated,
                  })}
                >
                  <a href="#" onClick={createFreeAccount}>
                    <img src={IconCheck} alt="" />
                    Create a <strong>free account</strong> <br /> and save your
                    results{" "}
                  </a>
                </div>
              </div>

              <div className="inner_date">
                <a
                  href="#"
                  onClick={() =>
                    setActiveResult((a) => {
                      if (activeResult == 0) {
                        return a;
                      } else {
                        setEditingNote(false);
                        setNoteValue("");
                        return a - 1;
                      }
                    })
                  }
                  className={classNames("px-2 flex align-middle", {
                    "opacity-50": activeResult == 0,
                  })}
                >
                  <img src={ArrowPreviousDate} alt="" />
                </a>

                <div className="relative">
                  <a href="#" className="text-base text-black" id="show_note">
                    {results[activeResult].assessmentDateString}
                    <img
                      src={IconNote}
                      alt=""
                      onClick={() => setShowComment((k) => !k)}
                      className="inline-block px-1"
                    />
                  </a>
                </div>

                <a
                  href="#"
                  onClick={() =>
                    setActiveResult((a) => {
                      if (activeResult == results.length - 1) {
                        return a;
                      } else {
                        setEditingNote(false);
                        setNoteValue("");
                        return a + 1;
                      }
                    })
                  }
                  className={classNames("px-2 flex align-middle", {
                    "opacity-50": activeResult == results.length - 1,
                  })}
                >
                  <img src={ArrowNextDate} alt="" />
                </a>
              </div>
            </div>

            <div
              className={classNames("block-note", { "show-note": showComment })}
              id="note_content"
            >
              <p className="">
                <textarea
                  id="myTextarea"
                  value={editingNote ? noteValue : results[activeResult].note}
                  readOnly={!editingNote}
                  onChange={(e) => setNoteValue(e.target.value)}
                />
              </p>

              <a
                href="#"
                className=""
                onClick={async () => {
                  if (editingNote) {
                    await onEdit();
                  } else {
                    setEditingNote(true);
                  }
                }}
              >
                <img src={IconEditNote} alt="" className="m-auto" />
              </a>
            </div>

            <div className="scroll-content">
              {results[activeResult]?.assessmentData?.questions?.map(
                (k, index) =>
                  k && (
                    <AccordianItem
                      id={k.id}
                      isFirstResult={activeResult == 0}
                      title={k.title}
                      results={results}
                      imageSrc={
                        k?.imageFrame?.hash &&
                        `https://assessment-emotii-image.s3.amazonaws.com/${k?.imageFrame?.hash}.png`
                      }
                      score={parseInt(k.value * 100)}
                      accordianClass={colorClassArr[index % 4]}
                      rgbaColor={colorRGBAArr[index % 4]}
                      outOfText={"/100"}
                      showAccordianItem={!activeItem || activeItem == k.title}
                      isAccordianOpen={activeItem == k.title}
                      setActiveItem={setActiveItem}
                      diffValue={getDiffValue(k.title, index)}
                      createFreeAccount={createFreeAccount}
                    />
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    );
}

export default Result;
